import axios from '@/utilities/api/axios';

export const state = initialState();

export const actions = {
  createProjectRole: async (_, payload) => {
    try {
      const res = await axios.post(`/composed-bys`, payload);

      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  updateProjectRole: async (_, payload) => {
    try {
      const { composedById, ...body } = payload;

      const res = await axios.put(
        `/composed-bys/${composedById}`,
        body
      );

      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  deleteAllProjectRoles: async (_, payload) => {
    try {
      const { composedById } = payload;
      const res = await axios.delete(
        `/composed-bys/${composedById}`
      );
      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  }
};

export const mutations = {};

export const getters = {};

function initialState() {
  return {};
}
